import { QueryClient, QueryClientProvider } from "react-query";
export const queryClient = new QueryClient();

export default function WithReactQuery(component) {
  return function Wrapper() {
    return <QueryClientProvider client={queryClient}>{component()}</QueryClientProvider>;
  };
}
